import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AditivoOperacaoCreditoLivre } from '../../../model/operacao-garantida.model'
import { Dominio } from 'src/app/model/dominio-operacao.model';
import { AditivoOperacaoCreditoLivreService } from './aditivo.service';
import { MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { PermissaoService } from 'src/app/shared/permissao.service';
import { ROLE_GESTOR_ENVIO, ROLE_AGENTE_ENVIO } from 'src/app/constantes/permissao.constants';
import { GenerosLista } from 'src/app/model/generos-enum';

@Component({
    templateUrl: "./aditivo-popup.component.html",
    standalone: false
})
export class AditivoPopupComponent implements OnInit {
  public aditivo: AditivoOperacaoCreditoLivre;
  private dadosDominio: Dominio;
  private podeCancelar = false;

  constructor(
    private _activeModal: NgbActiveModal,
    private aditivoOperacaoCreditoLivreService: AditivoOperacaoCreditoLivreService,
    private messageService: MessageChannelService,
    private permissaoService: PermissaoService
  ) {}

  public ngOnInit() {
    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
      this.podeCancelar = resp && (resp[ROLE_GESTOR_ENVIO] || [ROLE_AGENTE_ENVIO]);
    });
  }

  public getValorAmortizacao(valor: number): string {
    if (valor == undefined) {
      return undefined;
    }
    return (Math.round(valor * 100) / 100).toFixed(2);
  }

  public fecharPopup() {
    this._activeModal.dismiss({});
  }

  get generoSocio() {
    if (this.aditivo.historicoAntesAditivo != null && this.aditivo.historicoAntesAditivo.generoSocioBeneficiario != null) {
      return GenerosLista.find(g => `${g.valor}` === this.aditivo.historicoAntesAditivo.generoSocioBeneficiario).nome;
    }
    return null
  }

  public nomeModalidadeOperacao(idModalidadeOperacao: string) {
    return this.dadosDominio.modalidades.filter(
      (item) => item.id === idModalidadeOperacao
    )[0].nome;
  }

  public podeCancelarReverterAditivo() {
    return this.podeCancelar && ![3, 9, 6].includes(Number(this.aditivo.detalhe.estado.id));
  }

  public cancelarAditivo() {
    this.aditivoOperacaoCreditoLivreService
      .cancelarAditivo(this.aditivo.id)
      .subscribe((msgRetorno) => {
        this.messageService.addMessage({
          title: "Sucesso",
          type: "CRUD_OPERATION",
          level: messageLevel.SUCCESS,
          message: msgRetorno.mensagem,
        });

        this._activeModal.close('aditivo-cancelado');
      });
  }

  ajustaCampoDate(data: any) {
    if (data == null ) return null;
    if (typeof data === "string") {
      if (data.length == 10) {
        data += " 00:00:00";
      }
      return new Date(data);
    }

    return data;
  }
}
